/**
 * Геометрия колеса фортуны — чистые функции без DOM.
 *
 * Секторы рисуются так же, как в утверждённом прототипе: сектор 0 стоит
 * по центру сверху (−90°), дальше по часовой стрелке. Указатель тоже сверху,
 * поэтому, чтобы выпавший сектор встал под указатель, колесо нужно довернуть
 * на −idx · 360/n градусов.
 *
 * Функции вынесены отдельно, чтобы поведение посадки сектора проверялось
 * тестом без браузера и canvas.
 */

const TAU_DEG = 360

// Пауза после ПОЛНОЙ остановки колеса, прежде чем подтвердить серверу, что
// приз показан. Только после этого подтверждения бот шлёт уведомление в чат
// (требование владельца: сообщение строго после остановки, задержка 3 с ок).
export const NOTICE_AFTER_STOP_MS = 3000

// Длительность CSS-анимации вращения (.fortune-wheel-rotor: transform 4.4s).
// Нужна как источник истины, если transitionend не пришёл (reduced motion,
// фон вкладки): результат показываем не раньше реальной остановки.
export const SPIN_ANIMATION_MS = 4400

// Страховка на случай, если transitionend не пришёл: считаем колесо
// остановившимся через длительность анимации + небольшой запас.
export const SPIN_FALLBACK_MS = SPIN_ANIMATION_MS + 800

function mod360(deg) {
  return ((deg % TAU_DEG) + TAU_DEG) % TAU_DEG
}

function safeCount(n) {
  const count = Math.floor(Number(n))
  return Number.isFinite(count) && count > 0 ? count : 1
}

function safeIndex(idx, n) {
  const i = Math.floor(Number(idx))
  if (!Number.isFinite(i) || i < 0) return 0
  return i >= n ? n - 1 : i
}

// Центр сектора idx при нулевом повороте колеса, в градусах (−90° = верх).
export function sectorCenterDeg(idx, n) {
  const count = safeCount(n)
  return -90 + safeIndex(idx, count) * (TAU_DEG / count)
}

// Каким должен стать поворот колеса по модулю 360°, чтобы сектор idx
// оказался под указателем сверху.
export function targetModDeg(idx, n) {
  const count = safeCount(n)
  const step = TAU_DEG / count
  return mod360(-safeIndex(idx, count) * step)
}

// Полный угол нового прокрута: текущий поворот + пять полных оборотов +
// добавка до нужной посадки. Угол только растёт, поэтому колесо всегда
// крутится вперёд, а не откатывается назад.
export function spinTargetRotation(idx, n, currentRotation, turns = 5) {
  const cur = Number(currentRotation)
  const base = Number.isFinite(cur) ? cur : 0
  const fullTurns = Number.isFinite(Number(turns)) ? Math.max(0, Math.floor(turns)) : 5
  const delta = mod360(targetModDeg(idx, n) - mod360(base))
  return base + TAU_DEG * fullTurns + delta
}
